import { action, computed, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'
import ModalViewModel from 'infra/ModalViewModel'
import { Membership } from 'iam/WorkspaceMembershipStore'

export default class CreateJobConfirmationDialogViewModel extends ModalViewModel {
  @observable
  confirmationInput = ''

  @observable
  membership: Membership | null = null

  constructor(
    private readonly initializeJobCallback: (
      membership: Membership,
    ) => Promise<void>,
  ) {
    super()
    makeObservable(this)

    this.close$.subscribe(this.reset)
  }

  @computed
  get workspaceName() {
    return this.membership?.workspace?.name ?? ''
  }

  @computed
  get memberName() {
    return this.membership?.member?.displayName ?? ''
  }

  @computed
  get canConfirm() {
    if (!this.membership) {
      return false
    }

    return (
      this.confirmationInput.trim() ===
      (this.membership.workspace.name?.trim() ?? '')
    )
  }

  @action.bound
  setInput(value: string) {
    this.confirmationInput = value
  }

  @action.bound
  open(membership: Membership) {
    if (this.showing) {
      return
    }

    this.membership = membership
    this.confirmationInput = ''
    super.show()
  }

  @action.bound
  reset() {
    this.confirmationInput = ''
    this.membership = null
  }

  confirm = task.resolved(async () => {
    if (!this.membership || !this.canConfirm) {
      return
    }

    try {
      await this.initializeJobCallback(this.membership)
      this.close()
    } catch (error) {
      console.error('Failed to initialize job creation', error)
    }
  })
}
